import { useMediaQuery } from 'react-responsive';

const getIsDesktop = () => useMediaQuery({ minWidth: 641 });

const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 641 })
    return isDesktop ? children : null
}

const getIsMobile = () => useMediaQuery({ maxWidth: 640 });

const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 640 })
    return isMobile ? children : null
}

const getIsSmallDesktop = () => useMediaQuery({ minWidth: 1280, maxWidth: 1535 });

export {
    getIsDesktop,
    Desktop,
    getIsMobile,
    Mobile,
    getIsSmallDesktop
};